import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_77: DocMigration = {
  maxSchemaVersion: "0.0.77",
  description: "Remove any malformed electrical loads",
  apply(json: any) {
    if (!json.electricalSystem?.loads) {
      return json;
    }

    const validLoads: { [id: string]: any } = {};
    const { loads } = json.electricalSystem;
    for (const loadId in loads) {
      const load = loads[loadId];

      if (!load.loadType) {
        continue;
      }

      validLoads[loadId] = load;
    }

    json.electricalSystem.loads = validLoads;

    return json;
  },
};

export default migration_0_0_77;
